import { Label } from "@/components/ui/label";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { SearchableSelector } from "@/components/searchable-selector";

/** Saved values stay selectable even when they are outside the current vocabulary. */
export function catalogChoices(options: string[], saved: string[]): string[] {
  return Array.from(new Set([...options, ...saved].filter(Boolean)));
}

export function CatalogChoice({ label, options, value, onChange, multiple = false, searchable = true }: {
  label: string;
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
  multiple?: boolean;
  searchable?: boolean;
}): JSX.Element {
  const [search, setSearch] = useState("");
  const choices = catalogChoices(options, value).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base", numeric: true }));
  return <div className="min-w-0 space-y-2">
    <Label>{label}</Label>
    {searchable && !multiple ? <SearchableSelector label={label} size="form" value={value[0] ?? ""}
      options={[{ value: "", label: "Unknown" }, ...choices.map((option) => ({ value: option, label: option }))]}
      onChange={(next) => onChange(next ? [next] : [])} /> : searchable ? <>
      <Input aria-label={`Search ${label}`} placeholder="Search…" value={search} onChange={(event) => setSearch(event.target.value)} />
      <select aria-label={label} multiple value={value}
        className="w-full min-w-0 rounded-md border border-input bg-background px-3 py-2 text-sm"
        onChange={(event) => {
          const visible = Array.from(event.target.options, (option) => option.value);
          const selected = Array.from(event.target.selectedOptions, (option) => option.value);
          onChange([...value.filter((saved) => !visible.includes(saved)), ...selected]);
        }}>
        {choices.filter((option) => option.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()))
          .map((option) => <option key={option} value={option}>{option}</option>)}
      </select>
    </> : <select aria-label={label} multiple={multiple} value={multiple ? value : value[0] ?? ""}
      className="w-full min-w-0 rounded-md border border-input bg-background px-3 py-2 text-sm"
      onChange={(event) => onChange(Array.from(event.target.selectedOptions, (option) => option.value).filter(Boolean))}>
      {!multiple ? <option value="">Unknown</option> : null}
      {choices.map((option) => <option key={option} value={option}>{option}</option>)}
    </select>}
    {multiple ? <p className="text-xs text-muted-foreground">Select all that apply; no selection means unknown. Search hides choices without clearing selections.</p> : null}
  </div>;
}
